import React, { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { useWallet } from '../hooks/useWallet';
import { refCode, SITE, intentUrl } from '../share';

// Share points: share a reveal on X, paste the tweet URL + wallet; a Pages Function verifies it via X oEmbed and stores points.
// Points are off-chain and may later give Gen1 priority/discount (docs/SHARE_POINTS.md). Not a token, no on-chain value.
export default function Points() {
  const { account } = useWallet();
  const [wallet, setWallet] = useState('');
  const [tweet, setTweet] = useState('');
  const [res, setRes] = useState(null);
  const [mine, setMine] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (account && !wallet) setWallet(account); }, [account, wallet]);
  const valid = ethers.isAddress(wallet.trim());

  const load = async (w = wallet.trim()) => {
    if (!ethers.isAddress(w)) return;
    try { const r = await fetch(`/api/points/${w}`); setMine({ status: r.status, ...(await r.json()) }); } catch (e) { setMine({ error: String(e) }); }
  };
  const submit = async () => {
    setBusy(true); setRes(null);
    try {
      const r = await fetch('/api/points/claim', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ tweetUrl: tweet.trim(), wallet: wallet.trim() }) });
      setRes({ status: r.status, ...(await r.json()) }); await load();
    } catch (e) { setRes({ error: String(e) }); }
    setBusy(false);
  };
  const ref = valid ? refCode(ethers.getAddress(wallet.trim())) : '';
  return (
    <div className="docs-container" style={{ maxWidth: 900 }}>
      <h1>Share points</h1>
      <p style={{ color: 'var(--muted)' }}>Share a reveal on 𝕏, paste the tweet link here, earn points. Points are planned to count toward Gen1 priority or discounts (points are not a token).
        10 points per verified share · max 3 shares per wallet per day · each tweet counts once.</p>
      <div className="card" style={{ marginTop: '1.2rem' }} data-testid="points-form">
        <h3>1. Share</h3>
        <p>Use “Share on 𝕏” after a reveal, or post any tweet with <b>{new URL(SITE).host}</b>{ref && <> or your ref code <b data-testid="ref-code">{ref}</b></>}.</p>
        {ref && <a className="rv-share" target="_blank" rel="noopener noreferrer" href={intentUrl(`Commanding my fleet in AgentFleet 🚀 @agentfleetbnb #AgentFleet ref ${ref}`, SITE)}>Quick share on 𝕏</a>}
        <h3 style={{ marginTop: '1.2rem' }}>2. Claim</h3>
        <div className="elig-row"><input data-testid="pts-wallet" value={wallet} onChange={(e) => setWallet(e.target.value)} placeholder="wallet 0x…" /></div>
        <div className="elig-row"><input data-testid="pts-tweet" value={tweet} onChange={(e) => setTweet(e.target.value)} placeholder="https://x.com/you/status/123…" />
          <button className="action-btn" data-testid="pts-claim" disabled={busy || !valid || !tweet} onClick={submit}>{busy ? 'Verifying…' : 'Verify & claim'}</button></div>
        {res && <p data-testid="pts-result" style={{ color: res.ok ? 'var(--cyan)' : 'var(--gold)', marginTop: '.6rem' }}>
          {res.ok ? `✓ +${res.added} points · total ${res.total} · ${res.todayLeft} shares left today` : `✗ ${res.error}`}</p>}
      </div>
      <div className="card" style={{ marginTop: '1rem' }} data-testid="points-mine">
        <h3>My points</h3>
        <button className="action-btn" disabled={!valid} onClick={() => load()}>Show points for {valid ? `${wallet.trim().slice(0, 6)}…${wallet.trim().slice(-4)}` : 'wallet'}</button>
        {mine && (mine.error && mine.status !== 200 ? <p style={{ color: 'var(--gold)', marginTop: '.6rem' }}>{mine.error}</p> : mine.total !== undefined && (
          <div style={{ marginTop: '.6rem' }}>
            <p className="price" data-testid="pts-total">{mine.total} pts</p>
            <p style={{ color: 'var(--muted)' }}>ref {mine.ref} · {mine.todayLeft} shares left today</p>
            {mine.claims.map((c) => <p key={c.tweet} style={{ fontSize: '.9rem' }}>+{c.pts} · <a href={`https://x.com/${c.author}/status/${c.tweet}`} target="_blank" rel="noopener noreferrer">@{c.author}/{c.tweet}</a> · {new Date(c.ts).toLocaleString()}</p>)}
          </div>))}
      </div>
    </div>
  );
}
